import { AudioRecordingObservable } from "@/store/audio-recordings";
import { AnyNoteVoiceSuggestion } from "@/store/note";

const VOICE_LABEL = "Voice";

export const useAudioCaptureIndicatorBehavior = ({
  audioRecording,
  noteSuggestion,
  isActiveRecording,
  isExpanded,
  isInsideNote,
}: {
  audioRecording?: AudioRecordingObservable | null;
  noteSuggestion?: AnyNoteVoiceSuggestion | null;
  isActiveRecording?: boolean;
  isExpanded: boolean;
  isInsideNote: boolean;
}) => {
  const shouldIncludeTextInLabel = isExpanded || isInsideNote;

  const displayDuration = (() => {
    if (!shouldIncludeTextInLabel) {
      return null;
    }

    if (noteSuggestion) {
      if (audioRecording && audioRecording.formattedDuration !== "00:00") {
        return audioRecording.formattedDuration;
      }

      return VOICE_LABEL;
    }

    if (audioRecording) {
      return audioRecording.formattedDuration;
    }

    // Show initial duration while the recording observable is still loading.
    if (isActiveRecording) {
      return "00:00";
    }

    return null;
  })();

  const shouldBeVisible = (() => {
    // If there is a note suggestion, it should be visible
    if (noteSuggestion) {
      return true;
    }

    if (audioRecording) {
      return true;
    }

    // Show the indicator immediately when an active recording exists,
    // even before the recording observable loads from the lazy store.
    if (isActiveRecording) {
      return true;
    }

    return false;
  })();

  return {
    shouldIncludeTextInLabel,
    displayDuration,
    shouldBeVisible,
  };
};
